/** Shared input styles for auth + onboarding registration forms. */

/** Canonical control height for login / signup / password screens. */
export const AUTH_CONTROL_MIN_HEIGHT = 36;

export const compactFieldSx = {
  border: "1px solid #D7DBDD",
  borderRadius: "6px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    fontSize: 13,
    fontWeight: 500,
    minHeight: AUTH_CONTROL_MIN_HEIGHT,
  },
  "& .MuiOutlinedInput-input": {
    py: "7px",
    px: 1.25,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiSelect-select": {
    py: "7px",
    px: 1.25,
    minHeight: "unset !important",
  },
};

/**
 * Apply on a form wrapper so TextFieldBox / TextField / Select match
 * the compact signup control size across login and onboarding auth.
 */
export const compactFormFieldsSx = {
  "& .MuiOutlinedInput-root": {
    minHeight: AUTH_CONTROL_MIN_HEIGHT,
  },
  "& .MuiOutlinedInput-input": {
    py: "7px",
    px: 1.25,
    fontSize: 13,
  },
  "& .MuiInputBase-input": {
    height: "auto",
  },
  "& .MuiSelect-select": {
    py: "7px",
    px: 1.25,
    minHeight: "unset !important",
    fontSize: 13,
  },
};

export const authFormFieldsSx = compactFormFieldsSx;

/** Login / auth field label typography. */
export const authFieldLabelSx = {
  fontWeight: 600,
  fontSize: 13,
  lineHeight: 1.25,
  color: "#58595B",
};

/**
 * Soft elevated pill used for onboarding question inputs
 * (text, search, and multiselect shells).
 */
export const ONBOARDING_INPUT_RADIUS = "16px";
export const ONBOARDING_INPUT_SHADOW = "0 8px 24px rgba(23, 15, 74, 0.08)";
export const ONBOARDING_INPUT_SHADOW_FOCUS = "0 8px 28px rgba(74, 44, 245, 0.12)";
export const ONBOARDING_INPUT_BORDER = "1px solid rgba(88, 89, 91, 0.12)";

/** Apply to TextField / TextFieldBox wrappers in onboarding question steps. */
export const onboardingQuestionFieldSx = {
  width: "100%",
  border: `${ONBOARDING_INPUT_BORDER} !important`,
  borderRadius: `${ONBOARDING_INPUT_RADIUS} !important`,
  backgroundColor: "#FFFFFF",
  boxShadow: ONBOARDING_INPUT_SHADOW,
  overflow: "hidden",
  transition: "border-color 160ms ease, box-shadow 160ms ease",
  "& .MuiOutlinedInput-root": {
    borderRadius: ONBOARDING_INPUT_RADIUS,
    minHeight: 52,
    backgroundColor: "#FFFFFF",
  },
  "& .MuiOutlinedInput-input": {
    py: "14px",
    px: "20px",
    fontSize: 15,
    fontWeight: 500,
    color: "#171717",
    "&::placeholder": {
      color: "rgba(88, 89, 91, 0.55)",
      opacity: 1,
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "&:focus-within": {
    borderColor: "rgba(74, 44, 245, 0.35) !important",
    boxShadow: ONBOARDING_INPUT_SHADOW_FOCUS,
  },
};

/** Shell styles for ChipSearchDropdown / SelectedChipsArea in onboarding. */
export const onboardingMultiSelectShellSx = {
  minHeight: 52,
  borderRadius: ONBOARDING_INPUT_RADIUS,
  border: ONBOARDING_INPUT_BORDER,
  backgroundColor: "#FFFFFF",
  boxShadow: ONBOARDING_INPUT_SHADOW,
  transition: "border-color 160ms ease, box-shadow 160ms ease",
  "&:focus-within": {
    backgroundColor: "#FFFFFF",
    borderColor: "rgba(74, 44, 245, 0.35)",
    boxShadow: ONBOARDING_INPUT_SHADOW_FOCUS,
  },
};

/** Revenue min/max input shells in onboarding. */
export const onboardingRangeInputShellSx = {
  border: ONBOARDING_INPUT_BORDER,
  borderRadius: ONBOARDING_INPUT_RADIUS,
  backgroundColor: "#FFFFFF",
  boxShadow: ONBOARDING_INPUT_SHADOW,
  height: 52,
  overflow: "hidden",
  "&:focus-within": {
    borderColor: "rgba(74, 44, 245, 0.35)",
    boxShadow: ONBOARDING_INPUT_SHADOW_FOCUS,
  },
};
